import { useEffect } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { handleOIDCCallback } from '../lib/auth'
import LoadingScreen from '../components/shared/LoadingScreen'
import Logo from '../components/shared/Logo'

export default function AuthLayout() {
  const { isAuthenticated, _hasHydrated } = useAuthStore()

  useEffect(() => {
    handleOIDCCallback()
  }, [])

  if (!_hasHydrated) return <LoadingScreen />
  if (isAuthenticated) return <Navigate to="/" replace />

  return (
    <div className="h-[100dvh] bg-bg-primary flex items-center justify-center p-4 fixed inset-0 overflow-y-auto overscroll-none">
      <div className="w-full max-w-md my-auto">
        {/* Logo */}
        <div className="text-center mb-8">
          <Logo size={48} className="mx-auto mb-3" />
          <h1 className="text-xl font-bold text-text-primary">ESI Energy Conductor</h1>
          <p className="text-sm text-text-secondary mt-1">Intelligent energy management</p>
        </div>

        <Outlet />
      </div>
    </div>
  )
}
